// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manual-check-container[data-v-12deddd9]{display:flex;justify-content:center;align-items:baseline;position:relative;bottom:40px;text-align:left}.manual-check-container__check-label[data-v-12deddd9]{font-size:12px;line-height:16px;letter-spacing:.32px}.manual-check-container__reset-button[data-v-12deddd9]{position:relative;bottom:-3px}", ""]);
// Exports
module.exports = exports;
